import { FiAlertTriangle } from '@react-icons/all-files/fi/FiAlertTriangle'
interface ErrorBlockProps {
  children: React.ReactNode
}
export const ErrorBlock = ({ children }: ErrorBlockProps) => (
  <div className='px-4 py-3 bg-red-600 text-sm shadow-md'>
    <div className='flex items-start space-x-2'>
      <FiAlertTriangle className='text-white flex-shrink-0' size={20} />
      <span className='text-white text-sm'>{children}</span>
    </div>
  </div>
)
